import { format, parseISO, isValid } from "date-fns";

// Conversión entre la cadena ISO que viaja al backend y el objeto de fecha que
// consume el selector de calendario. Vive en un punto único porque la comparten
// la creación de una propuesta y el ajuste de sus servicios: dos copias de la
// misma conversión de fechas se separan sin que nada falle, y el síntoma
// aparece lejos -- una fecha guardada con el formato de la otra pantalla.
//
// Una cadena vacía y una fecha inválida son lo mismo para el selector: ausencia
// de fecha. En la otra dirección devuelve cadena vacía, que NO es lo mismo que
// vaciar la fecha en el backend: el schema de la edición de servicios exige
// formato de fecha y rechaza la cadena vacía, así que quien consuma esto tiene
// que decidir qué manda cuando el usuario borra el campo.

export const strToDate = (str) => {
  if (!str) return null;
  try {
    const d = parseISO(str);
    return isValid(d) ? d : null;
  } catch {
    return null;
  }
};

export const dateToStr = (date) => {
  if (!date || !isValid(date)) return "";
  return format(date, "yyyy-MM-dd");
};
